import React, {Suspense, useEffect} from "react";
import {residentialNurse} from "types/enums/residential-nurse";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {HistoryExamine, Tabs} from "components/common";
import {Spin, TabsProps} from "antd";
import ListPatient from "./components/ListPatient/ListPatient";
import DetailInfo from "./components/DetailInfo/DetailInfo";
import Catalog from "./components/Catalog/Catalog";
import {setSiderKey} from "redux/reducer/common";

const Surgery = () => {
  const idSurgery = useAppSelector(e => e.residentialNurse.idSurgery);
  const dispatch = useAppDispatch();
  document.title = "Phẫu thuật";
  const items: TabsProps["items"] = [
    {
      key: residentialNurse.SURGERY.LIST_PATIENT,
      label: "Danh sách bệnh nhân",
      children: <ListPatient />,
    },
    {
      key: residentialNurse.SURGERY.INFO_DETAIL,
      label: "Chi tiết thông tin",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <DetailInfo />
        </Suspense>
      ),
      disabled: idSurgery ? false : true,
    },
    {
      key: residentialNurse.SURGERY.EXAM_HISTORY,
      label: "Lịch sử khám bệnh",
      children: (
        <HistoryExamine tabName={residentialNurse.SURGERY.LIST_PATIENT} />
      ),
      disabled: idSurgery ? false : true,
    },
    {
      key: residentialNurse.SURGERY.ADVANCE_SETTING,
      label: "Cấu hình danh mục phẫu thuật",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <Catalog />
        </Suspense>
      ),
    },
  ];
  const activeTab = useAppSelector(e => e.common.activeTab);
  useEffect(() => {
    dispatch(setSiderKey("phauThuat"));
  }, []);
  return (
    <div className="surgery page">
      <div className="main">
        <Tabs items={items} activeKey={activeTab} />
      </div>
    </div>
  );
};

export default Surgery;
